import { render, staticRenderFns } from "./materialShow.vue?vue&type=template&id=8517e37a&scoped=true&"
import script from "./materialShow.vue?vue&type=script&lang=js&"
export * from "./materialShow.vue?vue&type=script&lang=js&"
import style0 from "./materialShow.vue?vue&type=style&index=0&id=8517e37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8517e37a",
  null
  
)

export default component.exports